import { render, staticRenderFns } from "./WeeklyTop20.vue?vue&type=template&id=ea94ae44"
import script from "./WeeklyTop20.vue?vue&type=script&lang=js"
export * from "./WeeklyTop20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports